import React, { useRef, useState, useEffect } from 'react';
import { g as gsapWithCSS } from './index-RkBJ48Nr.js';
import { useTranslation } from 'next-i18next';
import Button from './components/Button/index.js';

const SkipNavigation = () => {
    const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
    const selector = '#shopping-bag > button';
    const ref = useRef(null);
    const [tl, setTl] = useState(null);
    const [show, setShow] = useState(false);
    useEffect(() => {
        const ctx = gsapWithCSS.context(() => {
            const timeline = gsapWithCSS.timeline({ paused: true });
            setTl(timeline);
        });
        return () => ctx.revert();
    }, []);
    useEffect(() => {
        const ctx = gsapWithCSS.context(() => {
            if (ref && tl) {
                ref.current.style.visibility = 'visible';
                const anim = tl.from(ref.current, { y: '-100%', duration: 0.2 });
                if (show) {
                    anim.play();
                }
                else {
                    anim.reverse();
                }
            }
        });
        return () => ctx.revert();
    }, [ref.current, show, tl]);
    const skip = () => {
        const content = document.querySelector(selector);
        if (content) {
            content.focus();
        }
    };
    return (React.createElement("div", { ref: ref, className: "skip-container", onFocus: () => {
            setShow(true);
        }, onBlur: () => {
            setShow(false);
        } },
        React.createElement(Button, { onClick: skip }, tButton('skipNavigation'))));
};

export { SkipNavigation as S };
//# sourceMappingURL=SkipNavigation-wioCm4mt.js.map
